import { call, put } from 'redux-saga/effects';
import { extractErrorFromResponse } from '../../assets/js/function-utils';
import ENDPOINTS from '../../consts/endpoints';
import api from '../../services/api';
import { Creators as HistoricoAcessoActions } from '../ducks/historico-acesso';

export function* buscarHistoricoAcesso(action) {
    const { codigoAcesso, chaveSegMais, chaveBroto } = action.payload;
    try {
        const { data } = yield call(api.get, ENDPOINTS.GET_HISTORICO_ACESSO(codigoAcesso, chaveSegMais, chaveBroto));
        yield put(HistoricoAcessoActions.setHistoricoAcessoSuccess(data.resultado));
    } catch (err) {
        yield put(HistoricoAcessoActions.setHistoricoAcessoFail(extractErrorFromResponse(err)));
    }
}
